import { SiteLayout } from './components/SiteLayout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { LearningPage } from './pages/LearningPage';
import { ActivitiesPage } from './pages/ActivitiesPage';
import { ActivityDetailPage } from './pages/ActivityDetailPage';
import { GraduatesPage } from './pages/GraduatesPage';
import { NewsPage } from './pages/NewsPage';
import { NewsPostPage } from './pages/NewsPostPage';
import { SupportPage } from './pages/SupportPage';
import { ContactPage } from './pages/ContactPage';
import { useLocation } from './router';

function ComingSoon() {
  return <section className="content-section"><p className="eyebrow">Hsa Thoo Lei</p><h1>Page in progress</h1></section>;
}

export function App() {
  const { pathname } = useLocation();
  let page = <ComingSoon />;
  if (pathname === '/') page = <HomePage />;
  else if (pathname === '/about') page = <AboutPage />;
  else if (pathname === '/learning') page = <LearningPage />;
  else if (pathname === '/activities') page = <ActivitiesPage />;
  else if (pathname.startsWith('/activities/')) page = <ActivityDetailPage id={decodeURIComponent(pathname.slice(12))} />;
  else if (pathname === '/graduates') page = <GraduatesPage />;
  else if (pathname === '/news') page = <NewsPage />;
  else if (pathname.startsWith('/news/')) page = <NewsPostPage slug={decodeURIComponent(pathname.slice(6))} />;
  else if (pathname === '/support') page = <SupportPage />;
  else if (pathname === '/contact') page = <ContactPage />;
  return <SiteLayout>{page}</SiteLayout>;
}

